export const initialState = {
  auditLogs: [],
  filters: {}
};
